export default __webpack_public_path__ + "static/media/ICON2.1a22c40b.svg";